export default __webpack_public_path__ + "static/media/Freighter_Grey.cc00866b.svg";